import React from 'react'
import {Select} from "antd"

const SelectSearch = (props) => {
    const {listSelect, name, label, value} = props

    const _handleChangeSelect = (value) => {
        props.onChange(name, value)
    }

    return (
        <div className="FilterSelect">
            <label htmlFor={name}>{label}</label>

            {!!value ? <Select
                showSearch
                allowClear
                id={name}
                value={value}
                style={{width: '100%'}}
                placeholder="Search to Select"
                optionFilterProp="children"
                onChange={_handleChangeSelect}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={listSelect}
            /> : <Select
                showSearch
                allowClear
                id={name}
                style={{width: '100%'}}
                placeholder="Search to Select"
                optionFilterProp="children"
                onChange={_handleChangeSelect}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={listSelect}
            />}
        </div>
    )
}

export default SelectSearch
